import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectPresenceRefresh } from 'src/app/pages/presence-contact-register/state/presence-contact-register.selectors';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { presenceCallDetailsAdded, presenceCallDetailsUpdated } from './call-details-hub.actions';
import { CallDetailsHubBase } from './call-details-hub.base';

@Injectable()
export class PresenceCallDetailsHubService extends CallDetailsHubBase {
   wireUpHubEvents(): void {
      this.init(this.store.select(selectPresenceRefresh));
   }

   protected init(selector: Observable<boolean>): void {
      this.autoRefresh$ = selector;

      this.autoRefresh$.pipe(takeUntil(this.destroyed$)).subscribe((isAutoRefresh) => {
         this.ndtHubService.connection.on('AddCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(presenceCallDetailsAdded({ callDetail }));
            }
         });

         this.ndtHubService.connection.on('UpdateCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(presenceCallDetailsUpdated({ callDetail }));
            }
         });
      });
   }

   constructor(ndtHubService: NdtHubConnectionService, store: Store) {
      super(ndtHubService, store);
   }
}
